import React, {useState} from "react"
import styled from 'styled-components'
import { observer } from 'mobx-react'
import dynamic from "next/dynamic"

import Title from "~/components/HowItWorks/Title"
import Grid from "./Grid"
import Spacer from "~/components/Spacer"
import { 
  GRID_THEME, 
  BENEFITS_GRID_CONTENT, 
  PROCESS_GRID_CONTENT, 
  BENEFITS_COLUMNS, 
  PROCESS_COLUMNS,
  BENEFITS_ICON_STYLE,
  PROCESS_ICON_STYLE
} from "./Grid/constants"
import WinItButton from "~/components/WinItButton"
import colors from "~/style/constants/colors"

const CalculateModal = dynamic(() => import('./CalculateModal'))

const Text = styled.div`
  max-width: ${props => props.maxWidth ? props.maxWidth : null};
  width: ${props => props.width ? props.width : null};
  color: ${props => props.header ? props.theme.colors.text.header : props.theme.colors.primary};
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  font-size: ${props => props.fontSize ? props.fontSize : "1em"};
  text-align: center;
`

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const ButtonContainer = styled.div`
  width: 250px;
  height: 74px;
`

const GridContainer = styled.div`
  margin: 0 100px;
  ${props => props.theme.media.mobile`
    margin: 0;
  `};
`

const CategorySeparator = styled.div`
  min-height: 2px;
  background: black;
  width: 75%;
  margin: 0 auto;
`

const CategoryHeader = styled.div`
  text-align: center;
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  font-size: 36px;
  color: ${props => props.color ? props.color :"rgb(38,38,38)" };
`

const HowItWorks = () => {
  const [openModal, setOpenModal] = useState(false)
  return (
    <>
      <Title />
      <Spacer mobile={60} desktop={100} />
      <CategoryHeader color={colors.primary.blue}>Parking Tickets</CategoryHeader>
      <Grid 
        COLUMN_CONTENT={PROCESS_GRID_CONTENT} 
        GRID_THEME={GRID_THEME} 
        COLUMNS={PROCESS_COLUMNS} 
        ICON_STYLE={PROCESS_ICON_STYLE} 
      />
      <Spacer mobile={25} desktop={45} />
      <CategorySeparator />
      <Spacer mobile={25} desktop={45} />
      <GridContainer>
        <CategoryHeader color={colors.ui.errorRed}>Traffic Tickets</CategoryHeader>
        <Grid 
          COLUMN_CONTENT={BENEFITS_GRID_CONTENT} 
          GRID_THEME={GRID_THEME} 
          COLUMNS={BENEFITS_COLUMNS} 
          ICON_STYLE={BENEFITS_ICON_STYLE}
        />
      </GridContainer>
      <Spacer mobile={130} desktop={180} />
      <CalculateModal close={() => setOpenModal(false)} isOpen={openModal} />

    </>
  )
}

export default observer(HowItWorks)
